// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const LIKE_BUTTON_LABEL = "P\u00e1\u010di sa mi";
